import React, { useContext, useEffect, useState, useRef } from "react";
//Blog 
import {
  Navbar,
  BlogHero,
  LatestInsights,
  JoinUs,
  Footer,
  BlogPostHero1,
} from "../../Component";

import { FilterProvider } from "../../Component/FilterContext/FilterContext";

import { useScrollToTopWithDelay } from "../../hooks";

import {
  BlogsPageContent,
  BlogsPageContentProvider,
  LanguageProvider,
  AboutusPageContext,
  AboutusPageProvider,
} from "../../store";

import styles from "./Blogs.module.css";

const Blogs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const contentRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");

  useScrollToTopWithDelay(500);
  const {
    aboutusScreenDetails,
    loading: aboutLoading,
    error: aboutError,
  } = useContext(AboutusPageContext);

  useEffect(() => {
    if (aboutusScreenDetails) {
    }
  }, [aboutusScreenDetails]);

  const {
    blogsPageContentDetails,
    loading: blogsLoading,
    error: blogsError,
  } = useContext(BlogsPageContent) || {}; // Add a fallback here

  useEffect(() => {
    if (blogsPageContentDetails) {
    }
  }, [blogsPageContentDetails]);

  // Handle initial loading and data fetching
  useEffect(() => {
    console.log("Loading Status:", {
      aboutLoading,
      blogsLoading,
      aboutusScreenDetails: !!aboutusScreenDetails,
      blogsPageContentDetails: !!blogsPageContentDetails,
      documentReady: document.readyState,
      imagesLoaded,
    });

    const checkLoading = () => {
      if (
        !aboutLoading &&
        !blogsLoading &&
        aboutusScreenDetails &&
        blogsPageContentDetails &&
        document.readyState === "complete" &&
        imagesLoaded
      ) {
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }
    };

    checkLoading();

    // Fallback to hide loader after 5 seconds
    const fallbackTimer = setTimeout(() => {
      if (isLoading) {
        setIsLoading(false);
      }
    }, 5000);

    return () => clearTimeout(fallbackTimer);
  }, [
    aboutLoading,
    blogsLoading,
    aboutusScreenDetails,
    blogsPageContentDetails,
    imagesLoaded,
  ]);

  // Check if all images are loaded
  useEffect(() => {
    if (contentRef.current) {
      const images = contentRef.current.getElementsByTagName("img");
      let loadedImages = 0;
      const totalImages = images.length;

      const imageLoaded = () => {
        loadedImages++;
        if (loadedImages === totalImages) {
          setImagesLoaded(true);
        }
      };

      Array.from(images).forEach((img) => {
        if (img.complete) {
          imageLoaded();
        } else {
          img.addEventListener("load", imageLoaded);
          img.addEventListener("error", imageLoaded);
        }
      });

      return () => {
        Array.from(images).forEach((img) => {
          img.removeEventListener("load", imageLoaded);
          img.removeEventListener("error", imageLoaded);
        });
      };
    }
  }, []);

  if (isLoading) {
    return (
      <div className={styles.loaderWrapper}>
        <span className={styles.loader}></span>
      </div>
    );
  }

  return (
    <div ref={contentRef}>
      <LanguageProvider>
        <AboutusPageProvider>
          <BlogsPageContentProvider>
            <FilterProvider>
              <div className={styles.topbg}>
                <BlogPostHero1
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
                <BlogHero searchTerm={searchTerm} />
                <LatestInsights searchTerm={searchTerm} />
              </div>
            </FilterProvider>
            <div className={styles.container}>{/* <PopularResources /> */}</div>
          </BlogsPageContentProvider>
        </AboutusPageProvider>
      </LanguageProvider>
    </div>
  );
};

export default Blogs;
